import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const routesAll = (state) => resolveProp('entities.routes.allIds', state) || [];
const getRoutes = (state) => resolveProp('entities.routes.byId', state) || {};

export default createSelector(routesAll, getRoutes, (ids, routes) =>
    Object.keys(routes)
        .filter((key) => ids.includes(key))
        .reduce((state, key) => {
            state.push(routes[key]);
            return state;
        }, []),
);
